module.exports = __webpack_public_path__ + "media/assets/images/conference_room_forms/rows-form-a762c1498ac681b947f3f3178906f4ab.gif";